import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';

export const AdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const activeRole = authService.role();
  const employments = authService.employments();
  const isAuth = authService.isAuthenticated();

  const hasAdminEmployment = employments.some((e) => e.role === 'ROLE_ADMIN');
  // Root que eligió un local desde su panel: el token sigue siendo ROLE_ROOT, pero con ese local
  const isRootInVenue = activeRole === 'ROLE_ROOT' && !!authService.foodVenueId();

  if (isAuth && (activeRole === 'ROLE_ADMIN' || isRootInVenue)) {
    return true;
  }

  if (hasAdminEmployment) {
    return router.parseUrl('/role-section');
  }

  return router.parseUrl('/auth/login');
};
